import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { JavapiService } from '../../services/javapi.service';
import { Metodosui } from '../../services/metodosui';
import { MetodosgenService } from '../../services/metodosgen.service';
import { AdminCrudPage } from '../../pages/ajustes/admin-crud/admin-crud.page';

@Component({
  selector: 'app-inspecdatosareaestimado',
  templateUrl: './inspecdatosareaestimado.component.html',
  styleUrls: ['./inspecdatosareaestimado.component.scss'],
  standalone: false
})
export class InspecdatosareaestimadoComponent implements OnInit {

  @Input() areaId: string = '';
  @Input() estimado: any = null;
  @Input() defaultTipo?: string;

  current: any = {
    id: '0',
    area_id: '',
    tipo: 'PLANILLA',
    dias: 1,
    trabajadores: 1,
    turno: 'DIURNO',
    monto_diario: 35,
    cantidad: 0,
    costo: 0,
    subcontratista: '',
    comentario: ''
  };

  loading: boolean = false;

  // Autocomplete state
  subcontratistasList: any[] = [];
  filteredSubcontratistas: any[] = [];
  showSubDropdown = false;
  isSubRegistrado = false;
  addMovilidad: boolean = false;
  montoMovilidad: number = 20;

  constructor(
    private modalCtrl: ModalController,
    private javaService: JavapiService,
    private ui: Metodosui,
    private metodosGen: MetodosgenService
  ) { }

  ngOnInit() {
    this.current.area_id = this.areaId;
    if (this.estimado) {
      this.current = { ...this.estimado };
      const tipo = (this.current.tipo || 'GENERAL').toUpperCase();
      const cant = Number(this.current.cantidad) || 0;
      if (tipo === 'MATERIAL' && cant > 0) {
        this.current.costo = Math.round(((Number(this.current.costo) || 0) / cant) * 100) / 100;
      }
      if (this.current.subcontratista) {
        this.isSubRegistrado = true;
      }
      this.addMovilidad = false;
    } else {
      if (this.defaultTipo) {
        this.current.tipo = this.defaultTipo;
      }
      this.addMovilidad = true;
      this.montoMovilidad = 20;
      this.onTipoChange();
    }
    this.loadSubcontratistas();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  onTurnoChange() {
    if (this.current.tipo === 'PLANILLA') {
      this.current.monto_diario = this.current.turno === 'DIURNO' ? 35 : 40;
    }
  }

  onTipoChange() {
    // Reset defaults if needed when switching types
    if (this.current.tipo === 'PLANILLA') {
        this.onTurnoChange();
    }
    if (this.current.tipo === 'SUBCONTRATO') {
        this.loadSubcontratistas();
    }
    if (this.current.tipo === 'MOVILIDAD') {
        this.current.monto_diario = 20;
    }
  }

  async loadSubcontratistas() {
    try {
      const data: any = await firstValueFrom(
        this.javaService.getCommonModel(
          this.metodosGen.setModeloGeneral('selDtsList', 'trSubcontratistas', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '')
        )
      );
      if (Array.isArray(data)) {
        this.subcontratistasList = data.map(c => ({ id: c.dt1, nombre: c.dt2 }));
      }
    } catch (e) {
      console.error('Error loading subcontratistas', e);
    }
  }

  filterSubcontratistas(event: any) {
    const q = (event.target?.value || '').toLowerCase();
    this.current.subcontratista = event.target?.value || '';
    this.filteredSubcontratistas = this.subcontratistasList.filter(s => s.nombre.toLowerCase().includes(q));
    this.showSubDropdown = true;
    this.isSubRegistrado = false; // Reset on type
  }

  selectSubcontratista(s: any) {
    this.current.subcontratista = s.nombre;
    this.showSubDropdown = false;
    this.filteredSubcontratistas = [];
    this.isSubRegistrado = true;
  }

  clearSubcontratista() {
    this.current.subcontratista = '';
    this.showSubDropdown = false;
    this.filteredSubcontratistas = [];
    this.isSubRegistrado = false;
  }

  closeSubDropdown() {
    setTimeout(() => {
        this.showSubDropdown = false;
    }, 300);
  }

  async createSubcontratista(nombre?: string) {
    const rawName = nombre || this.current.subcontratista;
    if (!rawName || !rawName.trim()) return;
    
    this.showSubDropdown = false;
    this.loading = true;
    try {
      const res: any = await firstValueFrom(
        this.javaService.getCommonModel({
          empresa: 'pgarcia2',
          rutina: 'genUpdate',
          subrutina: 'upsertSubcontratista',
          usuario: this.getUsuario(),
          datos: { dt1: rawName.trim(), dt2: '', dt3: '', dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '', dt11: '', dt12: '', dt13: '', dt14: '', dt15: '' }
        })
      );
      if (res && res.length > 0) {
        const newItem = { id: res[0].dt1, nombre: rawName.trim() };
        this.subcontratistasList.push(newItem);
        this.selectSubcontratista(newItem);
        this.ui.showToast(`Subcontratista "${rawName}" creado con éxito`, 'success');
      }
    } catch (e) {
      console.error('Error creating subcontratista', e);
      this.ui.showToast('Error al crear subcontratista', 'danger');
    } finally {
      this.loading = false;
    }
  }

  async openAdminSubcontratistas() {
    this.showSubDropdown = false;
    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: { entity: 'SUBCONTRATISTA', autoOpenAdd: false }
    });
    await modal.present();
    await modal.onDidDismiss();
    await this.loadSubcontratistas();
  }

  async save() {
    // Basic validations
    if (this.current.tipo === 'PLANILLA' && (this.current.dias <= 0 || this.current.trabajadores <= 0)) {
        this.ui.showToast('Ingrese días y trabajadores válidos', 'warning');
        return;
    }
    if (this.current.tipo === 'MATERIAL' && this.current.cantidad <= 0) {
        this.ui.showToast('Ingrese una cantidad válida', 'warning');
        return;
    }
    if (this.current.tipo === 'MOVILIDAD' && (this.current.dias <= 0 || this.current.monto_diario <= 0)) {
        this.ui.showToast('Ingrese días y monto válidos', 'warning');
        return;
    }
    if (this.current.tipo === 'SUBCONTRATO') {
        if (!this.current.subcontratista) {
            this.ui.showToast('Ingrese el subcontratista', 'warning');
            return;
        }
        if (!this.isSubRegistrado) {
            this.ui.showToast('Debe seleccionar un subcontratista de la lista o crearlo', 'warning');
            return;
        }
    }

    this.loading = true;
    try {
      // Calculate final cost based on type
      let finalCost = Number(this.current.costo) || 0;
      const isInsert = this.current.id === '0';
      
      if (this.current.tipo === 'PLANILLA') {
        const dias = Number(this.current.dias) || 0;
        const trab = Number(this.current.trabajadores) || 0;
        const monto = Number(this.current.monto_diario) || 0;
        finalCost = dias * trab * monto;
      } else if (this.current.tipo === 'MATERIAL') {
        const cant = Number(this.current.cantidad) || 0;
        const precio = Number(this.current.costo) || 0;
        finalCost = cant * precio;
      } else if (this.current.tipo === 'MOVILIDAD') {
        const dias = Number(this.current.dias) || 0;
        const monto = Number(this.current.monto_diario) || 0;
        finalCost = dias * monto;
      }

      // 1. Save main record using generic router
      const resp: any = await firstValueFrom(
        this.javaService.getCommonModel({
            empresa: 'pgarcia2',
            rutina: 'genUpdate',
            subrutina: 'saveEstimado',
            usuario: this.getUsuario(),
            datos: {
              dt1: isInsert ? 'INSERT' : 'UPDATE',
              dt2: String(this.current.id),
              dt3: String(this.current.area_id),
              dt4: this.current.tipo,
              dt5: String(this.current.dias),
              dt6: String(this.current.trabajadores),
              dt7: this.current.turno,
              dt8: String(this.current.monto_diario),
              dt9: String(this.current.cantidad),
              dt10: String(finalCost), 
              dt11: this.current.subcontratista,
              dt12: this.current.comentario,
              dt13: this.getUsuario(),
              dt14: '0', // linked_id
              dt15: ''
            }
        })
      );

      // 2. Handle linked mobility if PLANILLA + addMovilidad
      if (this.current.tipo === 'PLANILLA' && this.addMovilidad && isInsert && resp && resp.length > 0) {
          const planillaId = resp[0].dt1;
          const mobCost = (Number(this.current.dias) || 0) * (Number(this.montoMovilidad) || 0);
          
          await firstValueFrom(
            this.javaService.getCommonModel({
                empresa: 'pgarcia2',
                rutina: 'genUpdate',
                subrutina: 'saveEstimado',
                usuario: this.getUsuario(),
                datos: {
                  dt1: 'INSERT',
                  dt2: '0',
                  dt3: String(this.current.area_id),
                  dt4: 'MOVILIDAD',
                  dt5: String(this.current.dias),
                  dt6: '0',
                  dt7: '',
                  dt8: String(this.montoMovilidad),
                  dt9: String(this.current.dias),
                  dt10: String(mobCost), 
                  dt11: '',
                  dt12: 'Movilidad (Planilla #' + planillaId + ')',
                  dt13: this.getUsuario(),
                  dt14: String(planillaId), // LINKED!
                  dt15: ''
                }
            })
          );
      }

      this.ui.showToast('Estimado guardado correctamente');
      this.modalCtrl.dismiss(true);
    } catch (error: any) {
      this.ui.showToast('Error al guardar', 'danger');
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  async delete() {
    const confirm = await this.ui.showConfirmation('Eliminar Estimado', '¿Está seguro de eliminar este registro? (Se eliminarán gastos vinculados)', 'Eliminar');
    if (!confirm) return;

    this.loading = true;
    try {
      await firstValueFrom(
        this.javaService.getCommonModel({
            empresa: 'pgarcia2',
            rutina: 'genUpdate',
            subrutina: 'saveEstimado',
            usuario: this.getUsuario(),
            datos: {
              dt1: 'DELETE',
              dt2: String(this.current.id),
              dt3: String(this.current.area_id),
              dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '', dt11: '', dt12: '',
              dt13: this.getUsuario(),
              dt14: '0', dt15: ''
            }
        })
      );
      this.ui.showToast('Estimado eliminado');
      this.modalCtrl.dismiss(true);
    } catch (error: any) {
      console.error(error);
      this.ui.showToast('Error al eliminar', 'danger');
    } finally {
      this.loading = false;
    }
  }

  private getUsuario(): string {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      if (user.l_usuario) return user.l_usuario;
    }
    return 'system';
  }

}
